import React from "react";
import ContactForm from "../ContactForm";
import { ContactBoxTitle, ContactBoxWrapper } from "./styled";

const ContactBox = () => {
  return (
    <ContactBoxWrapper>
      <ContactBoxTitle>
        <span>Contact Me</span>
        <i className="lab la-telegram-plane"></i>
      </ContactBoxTitle>

      <ContactForm />
    </ContactBoxWrapper>
  );
};

export default ContactBox;
